import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import InfoIcon from "@mui/icons-material/Info";
import DownloadDoneIcon from "@mui/icons-material/DownloadDone";
import {
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ClassNameGenerator from "@mui/utils/ClassNameGenerator";
import moment from "moment";
import CustomAutoComplete from "../CommonComponents/CustomAutoComplete";
import CustomButton from "../CommonComponents/Button";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { companyWiseEmp } from "../../actions/Companywiseclient";

const ApproverAlreadyAssignedAlert = ({ userName }) => {
  const containerStyle = {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    borderRadius: "6px",
    border: "1px solid #fbbf24", // amber-300
    backgroundColor: "#fffbeb", // amber-50
    padding: "6px 10px",
    fontSize: "14px",
  };

  const iconStyle = {
    fontSize: "18px",
    flexShrink: 0,
    color: "#d97706", // amber-600
  };

  const textStyle = {
    flex: 1,
    color: "#92400e", // amber-800
    lineHeight: 1.5,
  };

  const buttonStyle = {
    flexShrink: 0,
    border: "1px solid #f59e0b", // amber-400
    backgroundColor: "transparent",
    color: "#b45309", // amber-700
    padding: "4px 10px",
    fontSize: "13px",
    borderRadius: "4px",
    cursor: "pointer",
  };

  return (
    <div style={containerStyle}>
      <WarningAmberIcon style={iconStyle} />

      <p style={textStyle}>
        Approver has already been assigned for{" "}
        <span style={{ fontWeight: 600 }}>{userName ?? "this user"}</span>.
        Please update the existing record instead.
      </p>
    </div>
  );
};

const ModalHeader = styled("div")({
  fontSize: "20px",
  fontWeight: "700",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  position: "sticky",
  top: 0,
  background: "#fff",
  zIndex: 9,
  paddingTop: "10px",
  paddingBottom: "10px",
  borderBottomLe: "1px slid red",
});
const ModalBody = styled("div")({
  padding: "15px",
});
export default function CompnayModal(props) {
  const {
    button,
    title,
    width,
    rowData,
    openModal,
    setOpenModal,
    ExpencesData,
    companyData,
    companyListHandle,
    companyUsers,
    companyUserListHandle,
    oldUsers,
    approveUserHandle,
    fetchUserApprover,
    companyUseId,
    companyId,
    siteList,
    siteListHandle,
    siteId,
    isRestrictedToEndUser = false,
    setIsRestrictedToEndUser = () => {},
    duplicateUsers = [],
    isLoading = false,
    setIsLoading = () => {},
  } = props;
  console.log("site oldUsers : ", oldUsers);
  const [open, setOpen] = React.useState(false);
  const [imageUrl, setImageUrl] = React.useState([]);
  const [isMultiLevelApproverEnabled, setIsMultiLevelApproverEnabled] =
    React.useState(false);
  const [multiLevelApproverArr, setMultiLevelApproverArr] = React.useState([
    { approver: null, isFinalApprover: false },
  ]);
  console.log("multiLevelApproverArr: ", multiLevelApproverArr);
  console.log("companyUseId: ", companyUseId);

  console.log("companyUsers in modal: ", companyUsers);
  const selectAllOption = { id: "selectAll", name: "Select All", empCode: "" };
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const handleOpen = (data) => {
    setImageUrl(data);
    setOpen(true);
  };
  const handleClose = () => {
    setOpenModal(false);
    setIsRestrictedToEndUser(false);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: width ? width : "50%",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "10px",
    // overflow: "hidden",
    // height: "50vh",
    // overflow: "auto",
    maxHeight: "80vh",
    overflow: "auto",
    paddingX: 3,
    paddingBottom: 3,
  };

  console.log(ExpencesData, "ExpencesData");
  const fetchCompanyConfigurationByCompanyId = async () => {
    const data = {
      companyId: companyId ? companyId.id : null,
      siteId: siteId?.id || null,
    };
    companyWiseEmp.fetchCompnyWiseUpdate(data).then((response) => {
      if (response !== null) {
        const multiLevelApproverToSet =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName === "COMPANY_WISE_MULTILEVEL_APPROVER",
          );

        const isMultiLevelApproverToSetTrue =
          multiLevelApproverToSet && multiLevelApproverToSet.length > 0
            ? multiLevelApproverToSet[0].isEnable === true
              ? true
              : false
            : false;

        console.log(
          "isMultiLevelApproverToSetTrue: ",
          isMultiLevelApproverToSetTrue,
        );

        setIsMultiLevelApproverEnabled(isMultiLevelApproverToSetTrue);

        // if(isMultiLevelApproverToSetTrue) {
        //   fetchMultiLevelApproverListForCompanyDetails
        // }

        if (response.responseCode === 404) {
          setIsMultiLevelApproverEnabled(false);
        }
        if (response.responseCode === 500) {
          setIsMultiLevelApproverEnabled(false);
        }
      } else {
        setIsMultiLevelApproverEnabled(false);
      }
    });
  };

  const handleChangeMultiLevelApproverArr = ({
    multiApproverItemIndex,
    isAddingNewInstance = false,
    isItemUpdation = false,
    isMultiApproverItem = false,
    multiApproverItem,
    isFinalApproverCheck = false,
    finalApproverCheck,
  } = {}) => {
    setMultiLevelApproverArr((prevArr) => {
      if (isAddingNewInstance) {
        const newInstance = { approver: null, isFinalApprover: false };
        return [...prevArr, newInstance];
      }
      if (isItemUpdation) {
        return prevArr.map((item, index) => {
          if (index === multiApproverItemIndex) {
            const updatedItem = { ...item };

            if (isMultiApproverItem) {
              updatedItem.approver = multiApproverItem;
            }

            if (isFinalApproverCheck) {
              updatedItem.isFinalApprover = finalApproverCheck;
            }

            return updatedItem;
          }
          return item;
        });
      }

      return prevArr;
    });
  };

  const handleDeleteMultiLevelApproverArr = (multiApproverItemIndex) => {
    setMultiLevelApproverArr((prevArr) => {
      return prevArr.filter((item, index) => index !== multiApproverItemIndex);
    });
  };

  const FetchSaveMultiLevelApproverForUser = async () => {
    if (
      multiLevelApproverArr.some((approver) => !Boolean(approver?.approver?.id))
    ) {
      alert("All fields are mandatory!");
      return;
    }
    if (!multiLevelApproverArr.some((approver) => approver?.isFinalApprover)) {
      alert("Please select atleast one Final Approver!");
      return;
    }
    if (!Boolean(companyId?.id)) {
      alert("plz Select a company");
      return;
    }
    if (Boolean(companyId?.isSiteConfigEnabled) && !Boolean(siteId?.id)) {
      alert("plz Select a Site");
      return;
    }
    if (!Boolean(companyUseId?.length)) {
      alert("plz Select CompanyUser Name ");
      return;
    }

    const payload = {
      hrmsCompanyId: companyId?.id || null,
      siteId: siteId?.id || null,
      createdBy: { id: JSON.parse(localStorage.getItem("data")).id },
      companyName: companyId.companyName || null,
      approverData: companyUsers
        ?.filter((rawItem) =>
          companyUseId?.some((useId) => useId === rawItem?.id),
        )
        ?.map((userItem) => {
          return {
            user: {
              id: userItem?.id || null, // Assuming user ID is same for all approvers
            },
            approver:
              multiLevelApproverArr?.map((item, index) => {
                return {
                  approverId: {
                    id: item?.approver?.id || null,
                  },
                  approverNo: index + 1,
                  isFinal: item?.isFinalApprover || false,
                };
              }) || [],
          };
        }),
    };

    console.log(
      "add payload for multi level approver at expense update: ",
      payload,
    );
    setIsLoading(true);

    const res = await companyWiseEmp?.saveMultiLevelApproverForComapny(payload);

    console.log("multi level approver res: ", res);
    if (res && res?.status === 200) {
      alert("Multi Level Approver added successfully");
      //   FetchMultiLevelApproverByCompanyId();
      if (isRestrictedToEndUser) {
        localStorage.setItem("holdApproverAtOdRestoreEmployee", true);
      }
      setIsLoading(false);
      window.location.reload(true);
    } else {
      // alert("Failed to save multi level approver");
      alert(res.response?.data?.responseDescription || res.message);
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    if (openModal) {
      const filteredArr = (
        siteId?.id
          ? companyUsers?.filter((item) => item?.siteId === siteId?.id)
          : companyUsers
      )?.filter((item) => item?.isApproverSet);
      console.log("site filteredArr : ", filteredArr);
      companyUserListHandle(filteredArr);
      setMultiLevelApproverArr([{ approver: null, isFinalApprover: false }]);
      if (companyId?.id) {
        fetchCompanyConfigurationByCompanyId();
      } else if (!companyId?.id) {
        setIsMultiLevelApproverEnabled(false);
      }
    }
  }, [companyId, openModal, siteId]);

  return (
    <div>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ModalHeader>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{ marginLeft: "15px" }}
            >
              {title}
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </ModalHeader>
          <ModalBody>
            <Grid
              xs={12}
              container
              direction="row"
              justifyContent="flex-start"
              sx={{ marginTop: "5px" }}
              //</ModalBody> alignItems="center"
            >
              {isRestrictedToEndUser ? (
                ""
              ) : (
                <>
                  <Grid item xs={2}>
                    Company*
                  </Grid>
                  <Grid item xs={8}>
                    <CustomAutoComplete
                      disablePortal
                      id="company"
                      options={(companyData !== undefined && companyData) || []}
                      value={companyId}
                      getOptionLabel={(option) => option.companyName}
                      sx={{ width: "auto" }}
                      onChange={(value, newVal) => companyListHandle(newVal)}
                      renderInput={(params) => (
                        <TextField {...params} label="Company" />
                      )}
                      size="small"
                    />
                  </Grid>
                </>
              )}
            </Grid>

            {!isRestrictedToEndUser && companyId?.isSiteConfigEnabled ? (
              <Grid
                xs={12}
                container
                direction="row"
                justifyContent="flex-start"
                sx={{ marginTop: "5px" }}
                //</ModalBody> alignItems="center"
              >
                <Grid item xs={2}>
                  Site*
                </Grid>
                <Grid item xs={8}>
                  <CustomAutoComplete
                    disablePortal
                    id="company"
                    options={(siteList !== undefined && siteList) || []}
                    value={siteId || null}
                    getOptionLabel={(option) => option.name}
                    sx={{ width: "auto" }}
                    onChange={(value, newVal) => siteListHandle(newVal)}
                    renderInput={(params) => (
                      <TextField {...params} label="Site" />
                    )}
                    size="small"
                  />
                </Grid>
              </Grid>
            ) : (
              ""
            )}

            <Grid
              xs={12}
              container
              direction="row"
              justifyContent="flex-start"
              sx={{ marginTop: "10px" }}
              //</ModalBody> alignItems="center"
            >
              <Grid item xs={2}>
                Company User*
              </Grid>
              <Grid item xs={8}>
                <CustomAutoComplete
                  // disablePortal
                  disableCloseOnSelect
                  limitTags={3}
                  id="user"
                  disabled={
                    companyUsers && companyUsers.length > 0 ? false : true
                  }
                  multiple
                  // options={
                  //   companyUsers && companyUsers === [] ? [] : companyUsers
                  // }
                  options={
                    Array.isArray(companyUsers) && Boolean(companyUsers?.length)
                      ? // ? companyUsers
                        [selectAllOption, ...companyUsers]
                      : []
                  }
                  // getOptionDisabled={(option) => option?.isApproverSet === true}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    // const filteredCompanyUsers = companyUsers?.filter(
                    //   (user) => !user?.isApproverSet
                    // );
                    const isSelectAll = option?.empCode === "";
                    const isAllSelected =
                      Boolean(companyUseId?.length > 0) &&
                      Boolean(companyUseId?.length === companyUsers?.length);
                    if (Boolean(option?.empCode === "")) {
                      return (
                        <li key={key} {...optionProps}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={isSelectAll ? isAllSelected : selected}
                          />
                          {Boolean(option?.empCode === "")
                            ? `${option?.name}`
                            : `${option?.name} (${option?.empCode})`}
                        </li>
                      );
                    }
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {Boolean(option?.empCode === "")
                          ? `${option?.name}`
                          : `${option?.name} (${option?.empCode})`}
                      </li>
                    );
                  }}
                  value={companyUsers.filter((item) =>
                    companyUseId.includes(item?.id),
                  )}
                  onChange={(value, newVal) => companyUserListHandle(newVal)}
                  getOptionLabel={({ name, empCode }) => {
                    if (Boolean(empCode === "")) {
                      return `${name}`;
                    }
                    return `${name} (${empCode})`;
                  }}
                  sx={{ width: "auto" }}
                  renderInput={(params) => (
                    <TextField {...params} label="Company Users" />
                  )}
                  size="small"
                />
              </Grid>
            </Grid>

            {isRestrictedToEndUser && Boolean(duplicateUsers?.length > 0) ? (
              <Grid
                xs={12}
                container
                direction="row"
                justifyContent="flex-start"
                sx={{ marginTop: "10px" }}
                //</ModalBody> alignItems="center"
              >
                <Grid item xs={10}>
                  <ApproverAlreadyAssignedAlert
                    userName={duplicateUsers?.map((u) => u?.name).join(", ")}
                  />
                </Grid>
              </Grid>
            ) : (
              ""
            )}

            {/* <Grid
              xs={12}
              container
              direction="row"
              justifyContent="flex-start"
              sx={{ marginTop: "10px" }}
              //</ModalBody> alignItems="center"
            >
              <Grid item xs={2}>
                Approver*
              </Grid>
              <Grid item xs={8}>
                <CustomAutoComplete
                  disablePortal
                  id="user"
                  disabled={oldUsers && oldUsers.length > 0 ? false : true}
                  options={oldUsers && oldUsers === [] ? [] : oldUsers}
                  // getOptionLabel={(option) => option.name}
                  getOptionLabel={({ name, empCode }) => {
                    return `${name} (${empCode})`;
                  }}
                  onChange={(value, newVal) => approveUserHandle(newVal)}
                  sx={{ width: "auto" }}
                  renderInput={(params) => (
                    <TextField {...params} label="Approver" />
                  )}
                  size="small"
                />
              </Grid>
            </Grid> */}
            {isMultiLevelApproverEnabled ? (
              <>
                {Boolean(multiLevelApproverArr?.length) && (
                  <>
                    {multiLevelApproverArr?.map(
                      (item, multiLevelApproverIndex) => {
                        return (
                          <Grid
                            key={multiLevelApproverIndex}
                            container
                            sx={{ marginTop: "10px" }}
                            spacing={2}
                          >
                            <Grid item xs={2}>
                              {`Approver ${multiLevelApproverIndex + 1}*`}
                            </Grid>

                            <Grid item xs={6} md={6.5}>
                              <CustomAutoComplete
                                size="small"
                                id="multiple-limit-tags"
                                value={item?.approver || null}
                                options={oldUsers.filter(
                                  (user) =>
                                    !multiLevelApproverArr.some(
                                      (approver) =>
                                        approver.approver?.id === user.id,
                                    ),
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value?.id
                                }
                                getOptionLabel={(option) =>
                                  `${option.name}(${option.empCode})`
                                }
                                disablePortal
                                onChange={(event, newValue) => {
                                  handleChangeMultiLevelApproverArr({
                                    multiApproverItemIndex:
                                      multiLevelApproverIndex,
                                    isItemUpdation: true,
                                    isMultiApproverItem: true,
                                    multiApproverItem: newValue,
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder={`Approver ${
                                      multiLevelApproverIndex + 1
                                    }*`}
                                  />
                                )}
                              />
                            </Grid>

                            <Grid item xs={2.5} md={1}>
                              <Tooltip
                                arrow
                                title="Final Approver"
                                PopperProps={{
                                  modifiers: [
                                    {
                                      name: "offset",
                                      options: {
                                        offset: [0, -10],
                                      },
                                    },
                                  ],
                                }}
                              >
                                <Checkbox
                                  disabled={
                                    !Boolean(item?.approver)
                                    // || (multiLevelApproverArr.some(
                                    //   (approver) => approver.isFinalApprover
                                    // ) &&
                                    //   !item.isFinalApprover)
                                  }
                                  checked={item?.isFinalApprover || false}
                                  onChange={(e) =>
                                    handleChangeMultiLevelApproverArr({
                                      isItemUpdation: true,
                                      isFinalApproverCheck: true,
                                      multiApproverItemIndex:
                                        multiLevelApproverIndex,
                                      finalApproverCheck: e.target.checked,
                                    })
                                  }
                                  color="primary"
                                />
                              </Tooltip>
                            </Grid>
                            {Boolean(multiLevelApproverIndex) && (
                              <Grid item xs={1}>
                                <Tooltip
                                  arrow
                                  title="Remove Approver"
                                  PopperProps={{
                                    modifiers: [
                                      {
                                        name: "offset",
                                        options: {
                                          offset: [0, -8],
                                        },
                                      },
                                    ],
                                  }}
                                >
                                  <IconButton
                                    sx={{
                                      bgcolor: "#ef2222",
                                      color: "white",
                                      "&:hover": { bgcolor: "#cf0f0f" },
                                    }}
                                    onClick={() =>
                                      handleDeleteMultiLevelApproverArr(
                                        multiLevelApproverIndex,
                                      )
                                    }
                                  >
                                    <DeleteIcon sx={{ fontSize: "18px" }} />
                                  </IconButton>
                                </Tooltip>
                              </Grid>
                            )}
                          </Grid>
                        );
                      },
                    )}
                    <Grid container spacing={2} sx={{ marginTop: "10px" }}>
                      <Grid item xs={10.5} md={9.5}></Grid>
                      <Grid item xs={1}>
                        <Tooltip
                          arrow
                          title="Add Another Approver"
                          PopperProps={{
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [0, -8],
                                },
                              },
                            ],
                          }}
                        >
                          <IconButton
                            sx={{
                              bgcolor: "#05a4f4",
                              color: "white",
                              "&:hover": { bgcolor: "#0489cc" },
                            }}
                            onClick={() =>
                              handleChangeMultiLevelApproverArr({
                                isAddingNewInstance: true,
                              })
                            }
                          >
                            <AddIcon sx={{ fontSize: "18px" }} />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </>
                )}
              </>
            ) : (
              <>
                <Grid
                  xs={12}
                  container
                  direction="row"
                  justifyContent="flex-start"
                  sx={{ marginTop: "10px" }}
                  //</ModalBody> alignItems="center"
                >
                  <Grid item xs={2}>
                    Approver*
                  </Grid>
                  <Grid item xs={8}>
                    <CustomAutoComplete
                      disablePortal
                      id="user"
                      disabled={oldUsers && oldUsers.length > 0 ? false : true}
                      options={oldUsers && oldUsers === [] ? [] : oldUsers}
                      // getOptionLabel={(option) => option.name}
                      getOptionLabel={({ name, empCode }) => {
                        return `${name} (${empCode})`;
                      }}
                      onChange={(value, newVal) => approveUserHandle(newVal)}
                      sx={{ width: "auto" }}
                      renderInput={(params) => (
                        <TextField {...params} label="Approver" />
                      )}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </>
            )}
          </ModalBody>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="flex-end"
            sx={{
              marginTop: "190px",
              ...(isRestrictedToEndUser &&
                Boolean(duplicateUsers?.length > 0) && {
                  opacity: 0.6,
                  filter: "grayscale(100%)",
                  pointerEvents: "none",
                }),
            }}
          >
            <CustomButton
              name={"Add User"}
              onClick={
                isMultiLevelApproverEnabled
                  ? FetchSaveMultiLevelApproverForUser
                  : fetchUserApprover
              }
            />
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
